import React from 'react';
import { connect } from 'react-redux';
import { ReactComponent as PlusIcon } from '../../static/assets/plus-circle.svg';
import { ReactComponent as MinusIcon } from '../../static/assets/minus-circle.svg';
import { ReactComponent as Trapezoid } from '../../static/assets/trapezoid.svg';
import { manipulateFourStapsChart } from '../../utils/dataSet/actions';
import {IS_DEVELOPMENT} from "../../constants";

class HorizontalCharsTab extends React.Component {
  state = {
    activeTab: "Policy",
    readyForManipulation : false,
    showInfoBox: null,
    showDropdownBox: null,
  }

  componentDidMount() {
    const that = this;
    setTimeout(function() {
        that.setState({ readyForManipulation: true });
      }, 3500);
  }

  handleInfoClick = (event) => {
    const id = event.currentTarget.getAttribute('id');
    if (this.state.showInfoBox === id) {
      this.setState({ showInfoBox: null });
    } else {
      this.setState({ showInfoBox: id });
    }
  }

  handleArrowClick = (event) => {
    const id = event.currentTarget.getAttribute('id');
    if (this.state.showDropdownBox === id) {
      this.setState({ showDropdownBox: null });
    } else {
      this.setState({ showDropdownBox: id });
    }
  }

  tabHandleClick = (event) => {
    const name = event.currentTarget.getAttribute('name');
    this.setState({ activeTab: name });
    this.setState({ readyForManipulation: false });
    if (this.tabTimeout) {
      clearTimeout(this.tabTimeout);
    }
    const that = this;
    this.tabTimeout = setTimeout(
      function() {
        that.setState({ readyForManipulation: true });
      }, 3500);
  }

  minusHandleClick = (event) => {
    const name = event.currentTarget.getAttribute('name');
    const objId = event.currentTarget.getAttribute('dataid');
    const value = event.currentTarget.getAttribute('value');
    const dropdownId = event.currentTarget.getAttribute('id');
    if (!this.state[dropdownId]) {
      this.setState({ [dropdownId]: !this.state[dropdownId] });
    }
    const id = `${name}-${value}`;
    if (parseInt(value, 10) - 1 > 0) {
      document.getElementById(id).classList.add('to-destroy');
      const that = this;
      setTimeout(
        function() {
          if (document.getElementById(id)) {
            document.getElementById(id).classList.remove('to-destroy');
            that.props.manipulateFourStapsChart(that.state.activeTab.toLowerCase(), objId, parseInt(value, 10) - 1);
            that.forceUpdate();
          }
        }, 500);
    }
  }

  plusHandleClick = (event) => {
    const objId = event.currentTarget.getAttribute('dataid');
    const dropdownId = event.currentTarget.getAttribute('id');
    const value = event.currentTarget.getAttribute('value');
    const value2 = event.currentTarget.getAttribute('value2');
    console.log(objId, dropdownId, value, value2)
    if (!this.state[dropdownId]) {
      this.setState({ [dropdownId]: !this.state[dropdownId] });
    }
    const isAsIsSmallerThatToBe = () => value < value2;
    if ((parseInt(value, 10) + 1 <= 4) && isAsIsSmallerThatToBe()) {
      this.props.manipulateFourStapsChart(this.state.activeTab.toLowerCase(), objId, parseInt(value, 10) + 1);
      this.forceUpdate();
    }
  }

  // <Radar name="asis" dataKey="value" stroke="#FA9917" fill="transparent" fillOpacity={0.6} />
// {/*teal curve*/}
// <Radar name="tobe" dataKey="value2" stroke="#33E1FF" fill="transparent" fillOpacity={0.6} />
  getHorizontalChartRendered(range) {
    const greyedOutRange = () => {
      switch (range['value2']) {
        case 0: //0s 2s
          return <div className={`four-section-wide grey-horisontal-fill horisontal-fill`}/>
        case 1: //0.5s 2s
          return <div className={`three-section-wide grey-horisontal-fill horisontal-fill`}/>
        case 2: //1s 2s
          return <div className={`two-section-wide grey-horisontal-fill horisontal-fill`}/>
        case 3: //1.5s 2s
          return <div className={`one-section-wide grey-horisontal-fill horisontal-fill`}/>
        default:
          return null;
      }
    }
    return <>
      {range['value'] > 0 &&
          <div className={`red-horisontal-fill horisontal-fill ${this.state.readyForManipulation ? 'manipulate' : ''}`}/>}
      {range['value'] > 1 &&
          <div className={`yellow-horisontal-fill horisontal-fill ${this.state.readyForManipulation ? 'manipulate' : ''}`}/>}
      {range['value'] > 2 &&
          <div className={`salad-horisontal-fill horisontal-fill ${this.state.readyForManipulation ? 'manipulate' : ''}`}/>}
      {range['value'] > 3 &&
          <div className={`green-horisontal-fill horisontal-fill ${this.state.readyForManipulation ? 'manipulate' : ''}`}/>}
      {greyedOutRange()}
    </>;
  }

  horisontalChartsRender(tabName) {
    const dataToRender = this.props.pmmQuestionnaireRanges[tabName];
    IS_DEVELOPMENT && console.log('horisontalChartsRender', dataToRender);
    return (
      dataToRender.map((range, index) => (
        <div className="horisontal-chart-row row" key={`${index}-${tabName}`}>
          <div className="col-3">
            <div className="inner-four-step-name-container">
              {range['label']}
              {range['info_text'] &&
                  <i id={range['id']} className="fas fa-info-circle" onClick={this.handleInfoClick}/>
              }
              {range['info_text'] &&
                  <div className="info-popover" style={this.state.showInfoBox === range['id']
                      ? {opacity: 1}
                      : {opacity: 0, display: 'none'}}><h3>{range['label']}</h3>{range['info_text']}
                  </div>
              }
            </div>
          </div>
          <div className="col-9">
            <div
                id={`${range['id']}-${this.state.activeTab}-dropdown`}
                className="four-steps-chart-control minus"
                dataid={range['id']}
                name={index}
                value={range['value']}
                onClick={this.minusHandleClick}>
              <MinusIcon/>
            </div>
            <div id={`${index}-${range['value']}`} className="horisontal-chart">
              {
                this.getHorizontalChartRendered(range)
              }
            </div>
            <div
                id={`${range['id']}-${this.state.activeTab}-dropdown`}
                className="four-steps-chart-control plus"
                name={index}
                dataid={range['id']}
                value={range['value']}
                value2={range['value2']}
                onClick={this.plusHandleClick}>
              <PlusIcon/>
            </div>
          </div>
          <div className="col-3"/>
          <div className="col-9 steps-info-container" style={{
            display: range['step_one_description'] || range['step_two_description'] || range['step_three_description'] || range['step_four_description'] ?
                'block' : 'none',
          }}>
            <i
                id={`${range['id']}-${this.state.activeTab}-dropdown`}
                className={
                  `fas ${this.state.showDropdownBox === `${range['id']}-${this.state.activeTab}-dropdown` ?
                      'fa-arrow-circle-up' : 'fa-arrow-circle-down'}`}
                onClick={this.handleArrowClick}
            />
            <div
                className={`row steps-info-inner-container ${this.state.showDropdownBox === `${range['id']}-${this.state.activeTab}-dropdown` ? 'visible' : ''}`}>
              <div className="col-3">
                {range['step_one_description']}
              </div>
              <div className="col-3">
                {range['step_two_description']}
              </div>
              <div className="col-3">
                {range['step_three_description']}
              </div>
              <div className="col-3">
                {range['step_four_description']}
              </div>
            </div>
          </div>
        </div>
        ))
    );
  }

  render() {
    const { activeTab } = this.state;
    return (
      <div className="tabs-container h-100 w-100 m-0 p-0">
        <ul className="nav nav-tabs" role="tablist">
          <li className="nav-item">
            <div
              className={`nav-link ${ activeTab === 'Policy' ? 'active' : ''  }`}
              name="Policy"
              onClick={this.tabHandleClick}
            >
              <Trapezoid className="trapezoid" />
              <span>Policy</span>
            </div>
          </li>
          <li className="nav-item">
            <div
              className={`nav-link ${ activeTab === 'Practice' ? 'active' : ''  }`}
              name="Practice"
              onClick={this.tabHandleClick}
            >
              <Trapezoid className="trapezoid" />
              <span>Practice</span>
            </div>
          </li>
          <li className="nav-item">
            <div
              className={`nav-link ${ activeTab === 'Platform' ? 'active' : ''  }`}
              name="Platform"
              onClick={this.tabHandleClick}
            >
              <Trapezoid className="trapezoid" />
              <span>Platform</span>
            </div>
          </li>
        </ul>

        <div className="tab-content h-100">
          <div className="tab-pane fade show active h-100" id="home" role="tabpanel" aria-labelledby="home-tab">
            <div className="horisontal-chart-row row header">
              <div className="col-3">
                Maturity Element
              </div>
              <div className="col">
                Base (1)
              </div>
              <div className="col">
                Enhanced (2)
              </div>
              <div className="col">
                Above Average (3)
              </div>
              <div className="col">
                High Performance (4)
              </div>
            </div>
            {(() => {
              switch (activeTab) {
              case 'Practice': return this.horisontalChartsRender('practice');
              case 'Platform': return this.horisontalChartsRender('platform');
              default: return this.horisontalChartsRender('policy');
              }
            })()}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    pmmQuestionnaireRanges: state.dataSet.activeDataSet.pmmQuestionnaireRanges,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    manipulateFourStapsChart(category, chartId, value) {
      dispatch(manipulateFourStapsChart(category, chartId, value));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HorizontalCharsTab);
